if (!customElements.get('product-faq')) {
  customElements.define(
    'product-faq',
    class ProductFaq extends HTMLElement {
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      connectedCallback() {
        this.initAccordionHandlers();
        this.dispatchEvent(new CustomEvent('product-faq:loaded', { bubbles: true }));
      }

      disconnectedCallback() {
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initAccordionHandlers() {
        const detailsElements = this.querySelectorAll(
          '.faq-item'
        );

        detailsElements.forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (detail.open) {
              detailsElements.forEach((otherDetail) => {
                if (otherDetail !== detail) {
                  otherDetail.removeAttribute('open');
                  otherDetail.querySelector('summary').setAttribute('aria-expanded', false);
                }
              });
            }
          });
        });
      }
      
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
